import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query candidateOfferLetterById($id: MongoID!) {
    cat {
      candidate {
        byId(_id: $id) {
          _id
          offer_letter {
            approved
            extended
            signed
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type CandidateOfferLetterById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['candidate']>['byId']>

const useCandidateOfferLetterById = (id: string): CandidateOfferLetterById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const candidate = data?.cat?.candidate?.byId ?? undefined
  return candidate
}

export { useCandidateOfferLetterById, document as candidateOfferLetterByIdDocument }
